import { registerPlugin } from '@capacitor/core';

export interface DeviceTimezoneInfo {
  /** IANA timezone ID from Android system, e.g. "Asia/Almaty" */
  id: string;
  /** Current total offset in minutes (base + DST if active) */
  currentOffsetMinutes: number;
}

export interface DeviceTimezonePlugin {
  getTimezone(): Promise<DeviceTimezoneInfo>;
}

export const DeviceTimezone = registerPlugin<DeviceTimezonePlugin>('DeviceTimezone');
